<div class="cover-container">
  <picture>
    <source [srcset]="url()" [media]="MEDIA_QUERY"/>
    <source [srcset]="thumbnailUrl()" [media]="THUMBNAIL_MEDIA_QUERY"/>
    <img
      [src]="url()"
      [class.d-none]="!imageLoaded()"
      class="img-fluid img-thumbnail"
      (load)="onImageLoad($event)"
      alt="Cover picture"/>
  </picture>
</div>
